export default __webpack_public_path__ + "static/media/1440 x 300 Tents Desktop.81b94c16.jpg";